export default {
  order_methods: {
    delivery: 'Bezorging',
    pickup: 'Afhalen',
    room_service: 'Ter plaatse',
    table_service: 'Ter plaatse',
  },
  time: '{{time}} min',
  asap: 'Direct',
  unavailable: 'Niet beschikbaar',
  ready_in: 'Klaar over ',
  buttons: {
    change: 'Wijzigen',
    see_hours: 'Bekijk tijden',
    change_location: 'Locatie wijzigen',
    change_time: 'Tijd wijzigen',
  },
};
